const isTauri = !!(window as unknown as Record<string, unknown>).__TAURI_INTERNALS__;

function show(id: string) {
  const el = document.getElementById(id);
  if (el) el.style.display = '';
}
function hide(id: string) {
  const el = document.getElementById(id);
  if (el) el.style.display = 'none';
}

async function routeWeb(hash: string) {
  if (hash === '#app' || hash === '#web') {
    hide('landing-root');

    // 确保 gate CSS 在弹窗前已加载
    await import('./web/webTheme.css');
    await import('./web/landing.css');

    const { showDownloadGate, showDisclaimer } = await import('./web/webGate');
    await showDownloadGate();

    const accepted = await showDisclaimer();
    if (!accepted) { window.location.hash = ''; return; }

    // 渲染免责声明到 index.html 关于弹窗
    const { renderDisclaimerHtml, WEB_DISCLAIMER } = await import('./shared/disclaimer');
    const dl = document.getElementById('disclaimer-list');
    if (dl) dl.innerHTML = renderDisclaimerHtml(WEB_DISCLAIMER);

    if (hash === '#app') {
      show('app-root');
      hide('web-root');
      const { bootstrapDownload } = await import('./web/webDownload');
      void bootstrapDownload(document.getElementById('app-root')!);
    } else {
      show('web-root');
      hide('app-root');
      await import('./web/webLayout.css');
      const { bootstrapWebApp } = await import('./web/webApp');
      void bootstrapWebApp(document.querySelector('#web-root') as HTMLElement);
    }
  } else {
    // Landing Page
    hide('app-root');
    hide('web-root');
    hide('app');
    show('landing-root');
    const { bootstrapLanding } = await import('./web/webLanding');
    void bootstrapLanding(document.getElementById('landing-root')!);
  }
}

if (isTauri) {
  import('./style.css');
  import('./app').then(({ bootstrapApp }) => {
    void bootstrapApp(document.querySelector('#app'));
  });
} else {
  // 初始路由
  void routeWeb(window.location.hash || '');

  // 监听 hash 变化（按钮点击切换路由）
  window.addEventListener('hashchange', () => {
    void routeWeb(window.location.hash);
  });
}
